module.exports = __webpack_public_path__ + "img/mastercard.a29dc6b4.svg";